import styled, { css } from 'styled-components'
import { SpaceKeys } from 'styles/spacingV3'

type SpaceDirection = 'horizontal' | 'vertical'

interface StyledSpaceProps {
  $direction: SpaceDirection
  $size: SpaceKeys
}

const Space = styled.div<StyledSpaceProps>`
  display: block;
  ${({ $direction, $size, theme }) =>
    $direction === 'horizontal'
      ? css`
          width: ${theme.spacing[$size]};
          height: 1px;
          display: inline-block;
        `
      : css`
          height: ${theme.spacing[$size]};
          width: 1px;
        `}

  opacity: 0;
  pointer-events: none;
`

export default Space
